import React, {useEffect, useState} from "react";
import {useQuery} from "@tanstack/react-query";
import {Card} from "../../../../components/card/card.jsx";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const IndividualMatchCard = ({title, body, entityId, entityName}) => {
    const {data: blob} = useQuery({
        queryKey: ['integration-logo', entityId],
        enabled: !!entityId,
        staleTime: 0,
        queryFn: async () => {
            const response = await fetch(`${API_KEEPER}/integration/logo/get/${entityId}`);

            if (!response.ok) throw new Error();

            const data = await response.blob();
            if (!data.size) return null;
            return data;
        }
    });

    const [imageSrc, setImageSrc] = useState(null);

    useEffect(() => {
        if (!blob) {
            setImageSrc(null);
            return;
        }

        const url = URL.createObjectURL(blob);
        setImageSrc(url);

        return () => URL.revokeObjectURL(url);
    }, [blob]);

    return (
        <div className={"w-full mt-2"}>
            <Card>
                {
                    imageSrc ? (
                        <div className={"bg-white px-[10px] py-[7px] border-b border-gray-300"}>
                            <img src={imageSrc} alt="interligation-img" className={"w-full h-full"}/>
                        </div>
                    ) : entityName && (
                        <div className={"bg-white px-[10px] py-[7px] border-b border-gray-300 text-center"}>
                            <h2 className={"m-0 font-bold"}>{entityName}</h2>
                        </div>
                    )
                }

                <div className={"bg-white px-[10px] py-[7px] border-b border-gray-300"}>
                    <h5 className={"m-0 font-semibold text-[#676a6c] flex gap-2"}>
                        {title}
                    </h5>
                </div>

                <Card.Body className={"p-[10px]"}>
                    {body}
                </Card.Body>
            </Card>
        </div>
    );
};

export default IndividualMatchCard;
